<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div class="w-full flex items-center">
      <div class="w-2px h-20px bg-purple-500"></div>
      <div class="ml-14px">{{ title }}</div>
      <el-button type="primary" size="small" class="ml-20px" @click="cancel" v-if="mode === 'view'"
        >返回</el-button
      >
    </div>
    <div class="mt-20px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="应用程序名称" prop="name">
              <el-input
                :disabled="canEdit"
                v-model="ruleForm.name"
                placeholder="请填写应用程序名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="应用程序地址" prop="loginUrl">
              <el-input
                :disabled="canEdit"
                v-model="ruleForm.loginUrl"
                placeholder="请填写应用程序地址"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跳转地址" prop="redirectURL">
              <el-input
                :disabled="canEdit"
                v-model="ruleForm.redirectURL"
                maxlength="50"
                placeholder="请填写跳转地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务类型" prop="type">
              <el-select :disabled="canEdit" v-model="ruleForm.type" placeholder="请选择业务类型">
                <el-option
                  v-for="(option, index) in businessType"
                  :key="index"
                  :label="option.displayName"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否第三方系统" prop="isRedirect">
              <el-radio-group :disabled="canEdit" v-model="ruleForm.isRedirect">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作台图标设置" prop="normalIcon">
              <div class="flex flex-col">
                <div class="flex">
                  <div class="w-1/2 flex flex-col">
                    <el-upload
                      class="w-80px h-80px border-1 border-dashed border-hex-d9d9d9 rounded-6px cursor-pointer relative overflow-hidden flex justify-center items-center avatar-uploader"
                      action=""
                      :before-upload="getFileContent1"
                      :http-request="uploadImage1"
                      :show-file-list="false"
                      :disabled="canEdit"
                    >
                      <el-image
                        :src="`${fileUrl}${ruleForm.normalIcon}`"
                        v-if="ruleForm.normalIcon"
                        fit="contain"
                        class="w-full h-full"
                      ></el-image>
                      <i
                        v-else
                        class="el-icon-plus font-28px text-hex-8c939d w-full text-center"
                      ></i>
                    </el-upload>
                    <div>默认图标</div>
                  </div>
                  <div class="w-1/2 flex flex-col">
                    <el-upload
                      class="w-80px h-80px border-1 border-dashed border-hex-d9d9d9 rounded-6px cursor-pointer relative overflow-hidden flex justify-center items-center avatar-uploader"
                      action=""
                      :before-upload="getFileContent2"
                      :http-request="uploadImage2"
                      :show-file-list="false"
                      :disabled="canEdit"
                    >
                      <el-image
                        :src="`${fileUrl}${ruleForm.hoverIcon}`"
                        v-if="ruleForm.hoverIcon"
                        fit="contain"
                        class="w-full h-full"
                      ></el-image>
                      <i
                        v-else
                        class="el-icon-plus font-28px text-hex-8c939d w-full text-center"
                      ></i>
                    </el-upload>

                    <div>选中图标</div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="ruleForm.loginType === 1 || ruleForm.loginType === 2 ? 12 : 24">
            <el-form-item label="登录方式" prop="loginType">
              <el-radio-group :disabled="canEdit" v-model="ruleForm.loginType" @input="radioChange">
                <el-radio v-for="item in loginTypeData" :key="item.value" :label="item.value">{{
                  item.label
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.loginType === 1 || ruleForm.loginType === 2">
            <el-form-item label="请求方式" prop="postType">
              <el-radio-group :disabled="canEdit" v-model="ruleForm.postType">
                <el-radio v-for="item in postTypeData" :key="item.value" :label="item.value">{{
                  item.label
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-button class="mb-20px" :disabled="canEdit" type="primary" @click="addParam"
            >添加登录参数</el-button
          >

          <el-col :span="24">
            <el-table
              :data="tableData"
              max-height="250"
              @cell-click="cellClick"
              v-loading="tableLoading"
              ref="table"
              border
            >
              <el-table-column type="index" align="center" label="序号" width="50" />
              <el-table-column
                align="left"
                header-align="center"
                prop="fieldsName"
                label="参数字段名称"
              >
                <template slot-scope="scope">
                  <div
                    class="wrap"
                    :contenteditable="scope.row.isRowEdit"
                    @blur="lossFocus($event, scope, 'fieldsName')"
                    @focus="getFocus(scope.row)"
                    v-text="scope.row.fieldsName"
                  ></div>
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                header-align="center"
                prop="fieldsType"
                label="参数类型"
              >
                <template slot-scope="scope">
                  <div
                    class="wrap"
                    :contenteditable="scope.row.isRowEdit"
                    @blur="lossFocus($event, scope, 'fieldsType')"
                    @focus="getFocus(scope.row)"
                    v-text="scope.row.fieldsType"
                  ></div>
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                header-align="center"
                prop="fieldsValue"
                label="参数字段内容"
              >
                <template slot-scope="scope">
                  <div
                    class="wrap"
                    :contenteditable="scope.row.isRowEdit"
                    @blur="lossFocus($event, scope, 'fieldsValue')"
                    @focus="getFocus(scope.row)"
                    v-text="scope.row.fieldsValue"
                  ></div>
                </template>
              </el-table-column>
              <el-table-column align="left" header-align="center" prop="type" label="加密方式">
                <template slot-scope="scope">
                  <div
                    class="wrap"
                    :contenteditable="scope.row.isRowEdit"
                    @blur="lossFocus($event, scope, 'type')"
                    @focus="getFocus(scope.row)"
                    v-text="scope.row.type"
                  ></div>
                </template>
              </el-table-column>
              <el-table-column align="left" header-align="center" prop="postType" label="提交方式">
                <template slot-scope="scope">
                  <div
                    class="wrap"
                    :contenteditable="scope.row.isRowEdit"
                    @blur="lossFocus($event, scope, 'postType')"
                    @focus="getFocus(scope.row)"
                    v-text="scope.row.postType"
                  ></div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="200">
                <template slot="header">
                  <p>操作</p>
                </template>
                <template slot-scope="scope">
                  <el-button
                    :disabled="canEdit"
                    size="mini"
                    @click="editRow(scope.row, scope.$index)"
                    >编辑</el-button
                  >
                  <el-button :disabled="canEdit" size="mini" @click="removeRow(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="24" v-if="!canEdit">
            <el-form-item class="flex justify-center items-center mt-20px">
              <el-button type="primary" @click="onSubmit">保存</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog
      class="small-dialog"
      v-dialogDrag
      append-to-body
      :visible.sync="dialogVisible"
      title="新增登录传参"
      :before-close="resetForm"
    >
      <el-form :model="dialogForm" :rules="dialogFormRules" ref="dialogForm" label-width="150px">
        <el-form-item label="参数字段名称" prop="fieldsName">
          <el-input
            v-model="dialogForm.fieldsName"
            size="small"
            clearable
            placeholder="请选择参数字段名称"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="参数字段类型" prop="fieldsType">
          <el-select
            v-model="dialogForm.fieldsType"
            clearable
            placeholder="请选择参数字段类型"
            @change="fieldTypechange"
          >
            <el-option label="系统参数" value="系统参数"></el-option>
            <el-option label="常量" value="常量"></el-option>
            <el-option label="账户" value="账户"></el-option>
            <el-option label="密码" value="密码"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="参考字段内容"
          prop="fieldsValue"
          v-if="dialogForm.fieldsType === '系统参数' || dialogForm.fieldsType === '常量'"
        >
          <el-select
            v-if="dialogForm.fieldsType === '系统参数'"
            v-model="dialogForm.fieldsValue"
            placeholder="请选择业务类型"
          >
            <el-option label="token" value="token"></el-option>
            <el-option label="userId" value="userId"></el-option>
            <el-option label="account" value="account"></el-option>
          </el-select>
          <el-input
            v-if="dialogForm.fieldsType === '常量'"
            v-model="dialogForm.fieldsValue"
            size="small"
            clearable
            placeholder="请输入常量"
            maxlength="200"
          />
        </el-form-item>
        <el-form-item label="加密类型" prop="type">
          <el-select v-model="dialogForm.type" placeholder="请选择加密类型">
            <el-option label="AES" value="AES"></el-option>
            <el-option label="DES" value="DES"></el-option>
            <el-option label="TripleDES" value="TripleDES"></el-option>
            <el-option label="RC4" value="RC4"></el-option>
            <el-option label="Rabbit" value="Rabbit"></el-option>
            <el-option label="MD5" value="MD5"></el-option>
            <el-option label="Base64" value="Base64"></el-option>
            <el-option label="Hex" value="Hex"></el-option>
            <el-option label="不加密" value="不加密"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="输入字符编码"
          prop="inEnc"
          v-if="
            dialogForm.type === 'AES' ||
              dialogForm.type === 'DES' ||
              dialogForm.type === 'TripleDES' ||
              dialogForm.type === 'RC4' ||
              dialogForm.type === 'Rabbit'
          "
        >
          <el-select v-model="dialogForm.inEnc" placeholder="请选择输入字符编码">
            <el-option label="Base64" value="Base64"></el-option>
            <el-option label="Base64url" value="Base64url"></el-option>
            <el-option label="Hex" value="Hex"></el-option>
            <el-option label="Latinl" value="Latinl"></el-option>
            <el-option label="Utf16" value="Utf16"></el-option>
            <el-option label="Utf16BE" value="Utf16BE"></el-option>
            <el-option label="Utf16LE" value="Utf16LE"></el-option>
            <el-option label="Utf8" value="Utf8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="加密方式"
          prop="mode"
          v-if="
            dialogForm.type === 'AES' ||
              dialogForm.type === 'DES' ||
              dialogForm.type === 'TripleDES'
          "
        >
          <el-select v-model="dialogForm.mode" placeholder="请选择加密方式">
            <el-option label="CBC" value="CBC"></el-option>
            <el-option label="CFB" value="CFB"></el-option>
            <el-option label="CTR" value="CTR"></el-option>
            <el-option label="CTRGladman" value="CTRGladman"></el-option>
            <el-option label="ECB" value="ECB"></el-option>
            <el-option label="OFB" value="OFB"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="填充方式"
          prop="pad"
          v-if="
            dialogForm.type === 'AES' ||
              dialogForm.type === 'DES' ||
              dialogForm.type === 'TripleDES'
          "
        >
          <el-select v-model="dialogForm.pad" placeholder="请选择填充方式">
            <el-option label="Ansix923" value="Ansix923"></el-option>
            <el-option label="Iso10126" value="Iso10126"></el-option>
            <el-option label="Iso97971" value="Iso97971"></el-option>
            <el-option label="NoPadding" value="NoPadding"></el-option>
            <el-option label="Pkcs7" value="Pkcs7"></el-option>
            <el-option label="ZeroPadding" value="ZeroPadding"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="秘钥"
          prop="key"
          v-if="
            dialogForm.type === 'AES' ||
              dialogForm.type === 'DES' ||
              dialogForm.type === 'TripleDES' ||
              dialogForm.type === 'RC4' ||
              dialogForm.type === 'Rabbit'
          "
        >
          <el-input v-model="dialogForm.key" size="small" clearable placeholder="请填写秘钥" />
        </el-form-item>
        <el-form-item label="密钥长度" prop="block" v-if="dialogForm.type === 'AES'">
          <el-select v-model="dialogForm.block" placeholder="请选择密钥长度">
            <el-option label="128" value="128"></el-option>
            <el-option label="192" value="192"></el-option>
            <el-option label="256" value="256"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="偏移量"
          prop="iv"
          v-if="
            dialogForm.type === 'AES' ||
              dialogForm.type === 'DES' ||
              dialogForm.type === 'TripleDES'
          "
        >
          <el-input v-model="dialogForm.iv" size="small" clearable placeholder="请填写偏移量" />
        </el-form-item>
        <el-form-item
          label="输出字符编码"
          prop="outEnc"
          v-if="
            dialogForm.type !== 'Base64' &&
              dialogForm.type !== '' &&
              dialogForm.type !== '不加密' &&
              dialogForm.type !== 'Hex'
          "
        >
          <el-select v-model="dialogForm.outEnc" placeholder="请选择输出字符编码">
            <el-option label="Base64" value="Base64"></el-option>
            <el-option
              label="Base64Upper"
              value="Base64Upper"
              v-if="dialogForm.type === 'MD5'"
            ></el-option>
            <el-option
              label="Base64Lower"
              value="Base64Lower"
              v-if="dialogForm.type === 'MD5'"
            ></el-option>
            <el-option
              label="Base64url"
              value="Base64url"
              v-if="dialogForm.type === 'MD5'"
            ></el-option>
            <el-option label="Base32" value="Base32" v-if="dialogForm.type === 'MD5'"></el-option>
            <el-option
              label="Base32Upper"
              value="Base32Upper"
              v-if="dialogForm.type === 'MD5'"
            ></el-option>
            <el-option
              label="Base32Lower"
              value="Base32Lower"
              v-if="dialogForm.type === 'MD5'"
            ></el-option>
            <el-option label="Hex" value="Hex"></el-option>
            <el-option label="Latinl" value="Latinl"></el-option>
            <el-option label="Utf16" value="Utf16"></el-option>
            <el-option label="Utf16BE" value="Utf16BE"></el-option>
            <el-option label="Utf16LE" value="Utf16LE"></el-option>
            <el-option label="Utf8" value="Utf8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交方式" prop="postType" v-if="ruleForm.postType !== 2">
          <el-select
            v-model="dialogForm.postType"
            placeholder="请选择提交方式"
            @change="changPostType"
          >
            <el-option label="header" value="header"></el-option>
            <el-option label="url" value="url"></el-option>
            <el-option label="form" value="form" v-if="ruleForm.postType === 1"></el-option>
            <el-option label="json" value="json" v-if="ruleForm.postType === 1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center items-center">
        <el-button type="primary" @click="submitForm('dialogForm')">保存</el-button>
        <el-button @click="resetForm()">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { SingleSignOnApi } from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { FileApi } from '@wiz-api/file-management'
import { loginType as loginTypeData, postType as postTypeData } from '../../js/config'

const singleSignOnApi = new SingleSignOnApi()
const dataCategoryApi = new DataCategoryApi()
const fileApi = new FileApi()
export default {
  data() {
    return {
      mode: '',
      ruleForm: {
        name: '',
        loginUrl: '',
        isRedirect: true,
        redirectURL: '',
        type: '',
        backgroundColor: '',
        normalIcon: '',
        hoverIcon: '',
        loginType: 0,
        postType: 0,
        contentType: 0,
        // accountParamName: '',
        // isEncryptAccount: true,
        // accountEncriptType: 0,
        // accountEncripyKey: '',
        // accountPublicKeyUrl: '',
        // pwdParamName: '',
        // isEncripty: true,
        // pwdEncriptType: 0,
        // pwdEncripyKey: '',
        // pwdPublicKeyUrl: '',
        moreParamSetting: '',
        loginCallBack: '',
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请填写应用程序名称', trigger: 'blur' }],
        loginUrl: [{ required: true, message: '应用程序地址', trigger: 'blur' }],
        type: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],

        normalIcon: [{ required: true, message: '请上传应用程序默认图标', trigger: 'blur' }],
        hoverIcon: [{ required: true, message: '请上传应用程序选中图标', trigger: 'blur' }],
      },
      businessType: [],
      selectCode: 'SingleBusinessType',
      tableData: [],
      file1: '',
      file2: '',
      tableLoading: false,
      loginTypeData,
      postTypeData,
      dialogVisible: false,
      dialogIsedit: false,
      dialogIndex: 0,
      dialogForm: {
        fieldsName: '',
        fieldsType: '',
        fieldsValue: '',
        type: '',
        inEnc: 'Utf8',
        mode: 'CBC',
        pad: 'Pkcs7',
        key: '',
        iv: '',
        outEnc: 'Utf8',
        postType: '',
        block: '',
      },
      dialogFormRules: {
        fieldsName: [{ required: true, message: '请填写参数字段名称', trigger: 'blur' }],
        fieldsType: [{ required: true, message: '请选择参数字段类型', trigger: 'change' }],
        fieldsValue: [{ required: true, message: '请选择参数字段内容', trigger: 'change' }],
        type: [{ required: true, message: '请选择加密类型', trigger: 'change' }],
        inEnc: [{ required: true, message: '请选择输入字符编码', trigger: 'change' }],
        mode: [{ required: true, message: '请选择加密方式', trigger: 'change' }],
        pad: [{ required: true, message: '请选择填充模式', trigger: 'change' }],
        key: [{ required: true, message: '请填写密钥', trigger: 'blur' }],
        block: [{ required: true, message: '请选择密钥长度', trigger: 'change' }],
        iv: [{ required: true, message: '请填写偏移量', trigger: 'blur' }],
        outEnc: [{ required: true, message: '请选择输出字符编码', trigger: 'change' }],
        postType: [{ required: true, message: '请选择提交方式', trigger: 'change' }],
      },
    }
  },
  mounted() {
    this.mode = this.$route.query.mode
    if (this.mode === 'view' || this.mode === 'edit') {
      this.ruleForm = this.$route.query.rowData
      if (this.ruleForm.moreParamSetting !== '') {
        this.tableData = JSON.parse(this.ruleForm.moreParamSetting)
        if (this.mode === 'view') {
          this.tableData.forEach((item) => {
            item.isRowEdit = false
          })
        }
      }
    }
    this.getBusinessType()
  },
  computed: {
    canEdit() {
      return this.$route.query.mode === 'view'
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },

    title() {
      switch (this.$route.query.mode) {
        case 'view':
          return '查看'
        case 'edit':
          return '编辑'
        default:
          return '新增'
      }
    },
  },
  methods: {
    async getBusinessType() {
      this.businessType = []
      const [err, res] = await dataCategoryApi.getByCode({
        code: this.selectCode,
        includeDetails: true,
      })
      if (!err) {
        this.businessType = res.dataItems
        if (this.mode === 'view' || this.mode === 'edit') {
          this.businessType.forEach((element) => {
            if (element.displayName === this.ruleForm.type) {
              this.ruleForm.type = element.id
            }
          })
        }
      }
    },
    async uploadImage1() {
      const [err, res] = await fileApi.upload({
        files: [this.file1],
        authLevel: 2,
      })
      if (!err) {
        this.ruleForm.normalIcon = res?.[0].id
      }
    },
    async uploadImage2() {
      const [err, res] = await fileApi.upload({
        files: [this.file2],
        authLevel: 2,
      })
      if (!err) {
        this.ruleForm.hoverIcon = res?.[0].id
      }
    },
    // 获取上传的内容
    getFileContent1(file) {
      if (
        !['jpg', 'jpeg', 'png'].includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
      ) {
        this.$message.warning('请上传图片格式文件')
        return false
      }
      this.file1 = file
      return true
    },
    getFileContent2(file) {
      if (
        !['jpg', 'jpeg', 'png'].includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
      ) {
        this.$message.warning('请上传图片格式文件')
        return false
      }
      this.file2 = file
      return true
    },
    cellClick() {},
    addParam() {
      this.dialogIsedit = false
      this.dialogVisible = true
    },
    lossFocus(e, scope, type) {
      const content = _.trim(e.target.textContent)
      switch (type) {
        case 'name':
          scope.row.name = content
          break
        case 'content':
          scope.row.content = content
          break
        default:
          break
      }
    },
    getFocus(row) {},
    editRow(row, index) {
      this.dialogForm = row
      this.dialogIndex = index
      this.dialogIsedit = true
      this.dialogVisible = true
    },
    removeRow(scope) {
      this.$confirm('是否删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.tableData.splice(this.tableData.indexOf(scope), 1)
          // if (scope.row.isAdd) {
          //   this.tableData.splice(scope.$index, 1);
          // } else {
          //   const res = await removeTemplateData({ id: scope.row.id });
          //   if (res && res.code === 0) {
          //     this.$message.success("删除成功");
          //     this.getList();
          //   } else {
          //     this.$message.error(res.msg);
          //   }
          // }
        })
        .catch(() => {})
    },
    async onSubmit() {
      if (this.tableData.length !== 0) {
        this.ruleForm.moreParamSetting = JSON.stringify(this.tableData)
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.mode === 'edit') {
            const [err, res] = await singleSignOnApi.updateAppssoSetting({ body: this.ruleForm })
            if (!err) {
              this.$message.success('更新成功')
              this.$router.go(-1)
            }
          } else {
            const [err, res] = await singleSignOnApi.addAppssoSetting({ body: this.ruleForm })
            if (!err) {
              this.$message.success('新增成功')
              this.$router.go(-1)
            }
          }
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogIsedit) {
            this.tableData[this.dialogIndex] = this.dialogForm
          } else {
            const index = _.findIndex(this.tableData, (item) => {
              return item.fieldsName === this.dialogForm.fieldsName
            })
            if (index !== -1) {
              return this.$message.warning('参数字段名称不能重复')
            }
            this.tableData.push(this.dialogForm)
          }
          this.resetForm()
        }
        return ''
      })
    },
    resetForm(done) {
      this.dialogForm = this.$options.data().dialogForm
      this.$nextTick(() => {
        this.$refs.dialogForm.clearValidate()
      })
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    changPostType(val) {
      if (val === 'form') {
        if (
          _.findIndex(this.tableData, (item) => {
            item.postType === 'json'
          }) !== -1
        ) {
          this.$message.warning('post提交方式应与录入数据保持一致')
          this.dialogForm.postType = 'json'
        }
      }
      if (val === 'json') {
        if (
          _.findIndex(this.tableData, (item) => {
            item.postType === 'form'
          }) !== -1
        ) {
          this.$message.warning('post提交方式应与录入数据保持一致')
          this.dialogForm.postType = 'form'
        }
      }
    },
    radioChange(row) {
      if (row === '直接跳转' || row === 'auth2.0') {
        this.ruleForm.postType = 2
      }
      this.dialogIndex = 0
      this.dialogIsedit = false
    },
    fieldTypechange(row) {
      this.dialogForm.fieldsValue = ''
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrap {
  white-space: pre-wrap;
}
</style>
